export function googleMapsApiLoader (consent, callbackAllowed = () => {}, callbackDisallowed = () => {}) {
    if (consent) {

        import('@googlemaps/js-api-loader').then(({Loader}) => {

            const loader = new Loader({
                apiKey: 'AIzaSyBtWF325CALZo-PVleNKlyBDaZiLhY9g_U',
                version: "weekly",
                libraries: ['geometry', 'places'],
                language: document.documentElement.getAttribute('lang')
            });

            callbackAllowed(loader);
        });
    } else {
        callbackDisallowed();
    }
}

export function handleModuleConsentText (el, accepted) {
    if(!el) return;

    if(accepted) {
        el.classList.add('d-none');
    } else {
        el.classList.remove('d-none');
    }
}